<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">API</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="container-center lg">
      <div class="panel panel-filled">
        <div class="panel-heading">
          <h1 class="text-grad">API Documentation (365.stream)</h1>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12">
              <div class="api-information">
                <div class="collection-description">
                  <h2 id="public-api-like-bxinth">
                    Private API
                  </h2>
                  <p>
                    Please see the information on this link "<router-link
                      to="/api-private"
                    >
                      Private API </router-link
                    >"
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="api-information">
                <div class="collection-description">
                  <h2 id="public-api-like-bxinth">
                    Public API
                  </h2>
                  <p>
                    To use the public API no authentication is required; simply
                    access any of the public API URLs and JSON encode data will
                    be returned.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="api-information">
                <div class="heading">
                  <div class="name">
                    <span class="GET method" title="GET">GET</span>
                    ASSETS
                  </div>
                </div>
                <div class="url">assets/</div>
                <div class="description">
                  <p>
                    GET:
                    <code
                      ><a v-bind:href="api_url + '/assets/'" target="_blank"
                        >{{ api_url }}/assets/</a
                      >
                    </code>
                  </p>
                  <p>
                    The assets endpoint is to provide a detailed summary for
                    each currency available on the exchange.
                  </p>
                  <pre>{{ assets }}</pre>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="api-information">
                <div class="heading">
                  <div class="name">
                    <span class="GET method" title="GET">GET</span>
                    TICKER
                  </div>
                </div>
                <div class="url">/</div>
                <div class="description">
                  <p>
                    GET:
                    <code
                      ><a v-bind:href="api_url + '/'" target="_blank"
                        >{{ api_url }}/</a
                      ></code
                    >
                  </p>
                  <p>
                    The ticker endpoint is to provide a 24-hour pricing and
                    volume summary for each market pair available on the
                    exchange.
                  </p>
                  <pre>{{ ticker }}</pre>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="api-information">
                <div class="heading">
                  <div class="name">
                    <span class="GET method" title="GET">GET</span>
                    ORDERBOOK
                  </div>
                </div>
                <div class="url">/orderbook/market_pair</div>
                <div class="description">
                  <p>
                    GET:
                    <code
                      ><a
                        v-bind:href="api_url + '/orderbook/USDT_BTC'"
                        target="_blank"
                        >{{ api_url }}/orderbook/USDT_BTC</a
                      ></code
                    >
                  </p>
                  <p>
                    The order book endpoint is to provide a complete level 2
                    order book (arranged by best asks/bids) with full depth
                    returned for a given market pair.
                  </p>
                  <pre>{{ orderbook }}</pre>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="api-information">
                <div class="heading">
                  <div class="name">
                    <span class="GET method" title="GET">GET</span>
                    TRADES
                  </div>
                </div>
                <div class="url">/trades/market_pair</div>
                <div class="description">
                  <p>
                    GET:
                    <code
                      ><a
                        v-bind:href="api_url + '/trades/USDT_BTC'"
                        target="_blank"
                        >{{ api_url }}/trades/USDT_BTC</a
                      ></code
                    >
                  </p>
                  <p>
                    The trades endpoint is to return data on all recently
                    completed trades for a given market pair.
                  </p>
                  <pre>{{ trades }}</pre>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="api-information">
                <div class="heading">
                  <div class="name">
                    <span class="GET method" title="GET">GET</span>
                    DEPTH ORDERS
                  </div>
                </div>
                <div class="url">/depth/market_pair</div>
                <div class="description">
                  <p>
                    GET:
                    <code
                      ><a
                        v-bind:href="api_url + '/depth/USDT_BTC'"
                        target="_blank"
                        >{{ api_url }}/depth/USDT_BTC</a
                      ></code
                    >
                  </p>
                  <p>
                    The depth orders endpoint is to provide a complete level 2
                    order book (arranged by best asks/bids) with full depth
                    returned for a given market pair.
                  </p>
                  <pre>{{ depth }}</pre>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="api-information">
                <div class="heading">
                  <div class="name">
                    <span class="GET method" title="GET">GET</span>
                    COINS PRICE
                  </div>
                </div>
                <div class="url">/coins</div>
                <div class="description">
                  <p>
                    GET:
                    <code
                      ><a v-bind:href="api_url + '/coins'" target="_blank"
                        >{{ api_url }}/coins</a
                      ></code
                    >
                  </p>
                  <p>
                    The coins endpoint is to return data on all coins price.
                  </p>
                  <pre>{{ coins }}</pre>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from "../../config";
export default {
  data() {
    return {
      api_url: API_URL,
      assets: {
        BTC: {
          type: "ENABLED",
          status: "LEGEND",
          _id: "5d70209b7836547c169dd04f",
          coin: "BTC",
          name: "Bitcoin",
          website: "https://bitcoin.org/",
          explorer: "https://btc.com/",
          contract_address: "BITCOIN",
          min_deposit: 0.0005,
          deposit_confirm: 2,
          withdraw_fee: 0.0005
        }
      },
      ticker: {
        USDT_BTC: {
          _id: "5d71329a5415cd3c9a7fb469",
          pair: "USDT_BTC",
          name: "Bitcoin",
          primary: "USDT",
          secondary: "BTC",
          rate_digi: 2,
          amount_digi: 5,
          volume_digi: 6,
          last_price: 10362.17,
          average: 10469.31,
          high: 10772.75,
          low: 10309.88,
          volume_24hrs: 0.062835,
          amount_24hrs: 675.86994,
          change: "-1.70",
          trade_count: 40
        }
      },
      orderbook: {
        bids: [
          {
            rate: 10201.8,
            volume: 0.07210226450575227
          },
          {
            rate: 10112.49,
            volume: 0.021038875833461992
          },
          {
            rate: 10112.07,
            volume: 0.043780699338927816
          }
        ],
        asks: [
          {
            rate: 10947.31,
            volume: 6.259557909246198
          },
          {
            rate: 10877.91,
            volume: 0.01921339054992057
          },
          {
            rate: 10877.91,
            volume: 0.07645344170781798
          }
        ]
      },
      trades: [
        {
          _id: "5d72db45f6e85e53ee0e4825",
          type: "SELL",
          rate: 10362.17,
          amount: 0.6661640695369844,
          volume: 0.00006428808536599809,
          timestamps: 1567808325000
        },
        {
          _id: "5d72d8d45467f942e3e972b1",
          type: "BUY",
          rate: 10394.13,
          amount: 0.687434858861878,
          volume: 0.00006613683481560055,
          timestamps: 1567807700000
        },
        {
          _id: "5d72d6d95467f942e3e971e4",
          type: "BUY",
          rate: 10406.91,
          amount: 0.869938138392323,
          volume: 0.00008359235723113998,
          timestamps: 1567807193000
        }
      ],
      depth: {
        bids: [
          [9706.89, 0.3498964409455889],
          [9708.05, 0.3432575169770066],
          [9708.39, 0.1438522652106695]
        ],
        asks: [
          [10188.52, 0.5681575963525455],
          [10190.06, 0.9554647985306685],
          [10191.06, 0.9598325985306685]
        ],
        last: 10018.21,
        pair: "USDT_BTC"
      },

      coins: {
        "365": {
          name: "365stream",
          last_price: 0.0015,
          change: 0
        },
        BTC: {
          name: "Bitcoin",
          last_price: 10024.83,
          change: -0.01
        },
        ETH: {
          name: "Ethereum",
          last_price: 211.02,
          change: -2.57
        },
        BCH: {
          name: "Bitcoin Cash",
          last_price: 307.19,
          change: -1.64
        },
        HBX: {
          name: "HashBX",
          last_price: 0.007,
          change: 0
        }
      }
    };
  }
};
</script>

<style scoped>
.api-information {
  padding: 15px 20px;
}
.api-information .heading .method {
  font-size: 16px;
  font-weight: 600;
  margin-right: 5px;
  text-transform: uppercase;
}
.GET,
.get {
  color: #3eb63e;
}
.api-information .heading .name {
  word-break: break-word;
  font-weight: 400;
  font-size: 18px;
  color: #fff;
}
.api-information .url {
  margin-bottom: 15px;
  word-break: break-all;
  padding: 6px 10px;
  border-radius: 3px;
  font-size: 12px;
  color: #949ba2;
  background-color: #494b54;
}
</style>
